import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('form-input', () => import(/* webpackMode: "lazy" */'./form-input'));
